import { DEADLINES } from '@witmetrics/utils/constants';
import { currentDate, getDeadlineDate } from '@witmetrics/utils/time';
import type { DateTimePreset } from './types';

export const DEADLINE_PRESETS: DateTimePreset[] = Object.values(DEADLINES).map(
  ({ name, label }) => ({
    label,
    getValue: () => getDeadlineDate(currentDate(), name),
  })
);
